"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _defaultPositionResolver = _interopRequireDefault(require("../../InternalOverlay/helpers/defaultPositionResolver"));

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0, _defineProperty2["default"])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

var positionResolver = function positionResolver(opts) {
  var trigger = opts.trigger;
  var position = (0, _defaultPositionResolver["default"])(opts);
  return _objectSpread(_objectSpread({}, position), {}, {
    width: trigger.width
  });
};

var _default = positionResolver;
exports["default"] = _default;


//////////////////
// WEBPACK FOOTER
// ./node_modules/react-rainbow-components/components/Lookup/helpers/lookupPositionResolver.js
// module id = aY/V
// module chunks = 0